import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { PERIOD_OVER_PERIOD_COLOR_SCALE } from "./constants";

const LegendItem = styled.span<{ $color: string }>`
    width: 8px;
    height: 8px;
    display: inline-block;
    margin-right: 2px;
    border-radius: 2px;
    background-color: ${({ $color }) => $color};
`;

export const TrafficByCountryMapLegend = () => {
    const t = useTranslation();
    return (
        <Flex
            justifyContent="center"
            alignItems="center"
        >
            <Text
                fontVariant="listItem3"
                color={colorsPalettes.carbon[250]}
                marginX="8px"
                marginY="0"
            >
                {t("demand.analysis.search.trends.map.legend.decline")}
            </Text>
            {[...PERIOD_OVER_PERIOD_COLOR_SCALE.red].reverse().map((color) => (
                <LegendItem
                    key={color}
                    $color={color}
                />
            ))}
            {PERIOD_OVER_PERIOD_COLOR_SCALE.green.map((color) => (
                <LegendItem
                    key={color}
                    $color={color}
                />
            ))}
            <Text
                fontVariant="listItem3"
                color={colorsPalettes.carbon[250]}
                marginX="8px"
                marginY="0"
            >
                {t("demand.analysis.search.trends.map.legend.growth")}
            </Text>
        </Flex>
    );
};
